import React, { useEffect, useState } from "react"
import { CSSTransition } from "react-transition-group"
import Modal from "../Modal"
import Spinner from "../Spinner"
import useGlobalState from "../helpers/useGlobalState"
import { modalInfoCenteredState } from "./store"

export enum BtnColor {
  YELLOW = "yellow",
  GREEN = "green",
  RED = "red",
}

type Props = {
  btnColor?: BtnColor
  onClick?: () => void
  phrases: {
    title: string
    description: string
    button: string
  }
  setIsModalOpen: React.Dispatch<React.SetStateAction<boolean>>
  onUpdate?: () => void
  children?: React.ReactNode
  buttons?: React.ReactNode
}

export default function ModalInfoCentered({
  btnColor = BtnColor.YELLOW,
  onClick,
  phrases,
  setIsModalOpen,
  children,
  buttons,
}: Props) {
  // const [isOpen, setIsOpen] = useState(false)
  const [modalState, setModalState] = useGlobalState(modalInfoCenteredState)

  const setIsOpen = (isOpen: boolean) => {
    setModalState((prev) => ({
      ...prev,
      isOpen,
    }))
    setIsModalOpen(isOpen)
  }

  return (
    // Spinner
    <>
      <CSSTransition
        in={modalState.isLoading}
        appear
        unmountOnExit
        classNames="fade"
        timeout={300}
      >
        <Spinner />
      </CSSTransition>
      <CSSTransition in={modalState.isOpen} appear unmountOnExit classNames="fade" timeout={300}>
        <Modal
          title={modalState.phrases.title}
          modalView="xs"
          cssModifyer="-info-centered"
          onRequestClose={() => setIsOpen(false)}
        >
          <div className="form-content">
            <p className="body-r-14">{modalState.phrases.description}</p>
            {children}
            <div className="modal-buttons">
              {buttons || (
                <button
                  type="button"
                  className={`wb-btn btn-${btnColor}`}
                  onClick={() => {
                    setIsOpen(false)
                    modalState.onClick?.()
                  }}
                >
                  <CSSTransition
                    in={true}
                    appear
                    unmountOnExit
                    classNames="fade"
                    timeout={300}
                  >
                    <span>{modalState.phrases.button}</span>
                  </CSSTransition>
                </button>
              )}
            </div>
          </div>
        </Modal>
      </CSSTransition>
    </>
  )
}
